/**
 * Page to list funding sources.  Used in the customer components (show customer's
 * funding sources), and FundingSources (my funding sources).
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address'

import PropTypes from 'prop-types';
import { Button, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, 
        Snackbar, SnackbarContent, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import Add from '@mui/icons-material/Add';
//import Clear from '@mui/icons-material/Clear';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CancelCircleOutline from '@mui/icons-material/Cancel';
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import ReportProblem from '@mui/icons-material/ReportProblem';

import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';

import ServerError from '../ui/ServerError';

import PaymentFormII from './PaymentFormII';
import ACHFormII from './ACHFormII';
import ACHFormIIPlaidMicro from './ACHFormIIPlaidMicro';
import FundingSourceTile from './FundingSourceTile';

import LoadingSpinner from '../ui/LoadingSpinner';
import PaymentSourceDialog from '../ui/PaymentSourceDialog';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import PaymentSourceUpdateMutation from './PaymentSourceUpdateMutation';
import PaymentSourceDeleteMutation from './PaymentSourceDeleteMutation';
import AccountUpdateMutation from '../account/AccountUpdateMutation';
import classNames from 'classnames';

import AccountInformationFetch from './AccountInformationFetch';
import InviteCustomerButton from '../ui/InviteCustomerButton';
import CurrencyNumberFormat2 from '../ui/CurrencyNumberFormat2';
import SavingSpinner from '../ui/SavingSpinner';
import PoweredBy from '../landing/PoweredBy';


import { red, yellow, green } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();

const FundingSourceListQuery = graphql`
query FundingSourceListQuery($accountId: UUID!, $activeOnly: Int, $purpose: Int) {
  paymentsourceswithaggregate7(accountid: $accountId, activeonly: $activeOnly, purpose: $purpose) {
    totalCount
    nodes {
      psId
      psType
      psStatus
      paidMtd
      paidLastMonth
      paidYtd
      paidLifetime
      ccBrand
      ccLast4
      ccExpy
      fiName
      achAccountNum
      firstName
      lastName
      extSource
      extPsId
      paypalEmail
      maxPsOrder
      maxPsOrderIn
      psStatusOther
      declineCount
      lastDeclineReason
      lastDeclineChargeAmount
      plaidAccessToken
      plaidItemId
      plaidAccountId
      plaidManualVerify
    }
  }
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountName
    accountStatus
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    marginTop: 16,
  },
  divider: {
    marginTop: 4,
    marginBottom: 20,
  },
  sectionBlock: {
    marginBottom: 12,  
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  },
  tblHeadCell: {
    textAlign: 'center',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  tblHeadCellR: {
    textAlign: 'right',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  tblHeadCellN: {
    textAlign: 'center',
    verticalAlign: 'bottom',
    borderBottom: 0,
    width: 32,
    paddingRight: 4,
    paddingLeft: 4,
  },
  tblHeadRow2: {
    height: 24,
  },
  tblHeadCell2: {
    textAlign: 'center',
    verticalAlign: 'top',
    //borderBottom: 0,
  },
  tblHeadRow3: {
    height: 32,
  },
  tblCellWidth100: {
    width: 100,
  },
  tblCellN: {
    width: 32,
    paddingRight: 4,
    paddingLeft: 4,
  },
  tblCellPriority: {
    paddingRight: 4,
    paddingLeft: 4,
  },
  iconbutton: {
    height: 28,
    width: 28,
  },
  iconbuttonicon: {
    marginTop: -10,
  },
  nonMenuStatus: {
    minWidth: 64
  },
  priorityGrid: {
    marginLeft: 14,
  },
  upbutton: {
    marginLeft: -17,
    //marginTop: 0,
    //marginBottom: -10,
  },
  priorityNum: {
    marginTop: -20,
    marginBottom: -10,
  },
  downbutton: {
    marginLeft: -17,
    //marginTop: -20,
    marginBottom: -10,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  [theme.breakpoints.up('sm')]: {
    tblCellDateCol: {
      paddingLeft: 10,
      paddingRight: 10,
      width: 50,
    },
    tblCellAppCol: {
      paddingLeft: 10,
      paddingRight: 10,
      minWidth: 200,
      width: 250,
    }
  },
  [theme.breakpoints.up('xs')]: {
    tblCellDateCol: {

    },
    tblCellAppCol: {

    }
  },
});

class FundingSourceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountFetched: false,
      addressFilled: false,
      primaryContactFilled: false,
      snackbarOpen: false,

      contactFirstName: '',
      contactLastName: '',
      contactEmail: '',
      contactEmailValid: null,
 
      country:    '',
      state:      '',
      city:       '',
      postalCode: '',
      address1:   '',
      address2:   null,
      showCCSpinner: false,
      showACHSpinner: false,

      ccOpen: false,
      achOpen: false,
      resellerName: '',
      activeOnly:  0,
      confirmDeactivate: false,
      activeList: '',
      rowMenuClicked: '',
      activeMenu: null,
      deactiveMenu: null,
      microdeposits: null,
      status: '',
      accessToken: null,
      showPlaidMicro: false,

      swapping: false
    };

    this.uInfo = null;
  }
   
  handleSnackbarClose = (event, reason) => { 
    this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
  };

  handleDeactiveMenuClose = () => {
    this.setState({deactiveMenu: null});
  }
  handleDeactiveMenuClick = (event, count) => {
    this.setState({deactiveMenu: event.currentTarget, rowMenuClicked: count});
  }

  handleActiveMenuClose = () => {
    this.setState({activeMenu: null});
  }

  handleActiveMenuClick = (event, count) => {
    this.setState({activeMenu: event.currentTarget, rowMenuClicked: count});
  }

  openCCDialog = (event) => {
    let url = '/fundingsources';
    localStorage.setItem('paymentReturn', url);
     this.setState({ccOpen: true});
  }
  openACHDialog = (event) => {
    let url = '/fundingsources';
    localStorage.setItem('paymentReturn', url);
    localStorage.removeItem('plaid');

     this.setState({achOpen: true});
  }

  handleCCClose = () => {
    if (abEnvironment.isSegmentActive()) { window.analytics.track('Credit card page closed'); }  
    localStorage.removeItem('paymentReturn');
    this.setState({ccOpen: false});
  };
    
  handleACHClose = () => {
    if (abEnvironment.isSegmentActive()) { window.analytics.track('ACH page closed'); }  
    localStorage.removeItem('paymentReturn');
    localStorage.removeItem('plaid');
    this.setState({achOpen: false});
  };

  handleACHMicroClose = () => {
    localStorage.removeItem('paymentReturn');
    localStorage.removeItem('plaid');
    this.setState({showPlaidMicro: false});
  };

  swapOrder(idx, theActives) {

    this.setState({swapping: true});
    let purpose = 0;
    if (this.props.purpose === 0 || this.props.purpose === 1 ) {
      purpose = this.props.purpose;
    }

    let ps1 = theActives[idx];
    let ps2 = theActives[idx+1];
    if (ps1 != null && ps2 != null) {
      // alert('Move ' + ps1.psId + ' to ' + (idx + 1) + ', ' + ps2.psId + ' to ' + idx);

      Promise.resolve()
      .then(() => {
        if (purpose === 0) {
          return PaymentSourceUpdateMutation.commit(ps1.psId, null, idx + 1, null, null);
        } else {
          return PaymentSourceUpdateMutation.commit(ps1.psId, null, null, null, idx + 1);

        }
      })
      .then(resp => {
        if (purpose === 0) {
          return PaymentSourceUpdateMutation.commit(ps2.psId, null, idx, null, null);
        } else {
          return PaymentSourceUpdateMutation.commit(ps2.psId, null, null, null, idx);
        }
      })
      .then(resp => {
        window.location.reload();
      })
      .catch(err => {
        window.location.reload();
      });
    }
  }

  async suspend(theActives) {

    let purpose = 0;
    if (this.props.purpose === 0 || this.props.purpose === 1 ) {
      purpose = this.props.purpose;
    }

    let idx = this.state.rowMenuClicked;
    let ps1 = theActives[idx];
    if (ps1 == null) {
      // alert('Cannot suspend');
    } else {
      try {
        if (purpose === 0) {
          let psum = await PaymentSourceUpdateMutation.commit(ps1.psId, 1, null, null, null);
        } else {
          let psum = await PaymentSourceUpdateMutation.commit(ps1.psId, null, null, 1, null);
        }

        for (let i=idx+1; i<theActives.length; i++) {
          let aPs = theActives[i];
          if (purpose === 0) {
            let aPsum = await PaymentSourceUpdateMutation.commit(aPs.psId, null, i-1, null, null);
          } else {
            let aPsum = await PaymentSourceUpdateMutation.commit(aPs.psId, null, null, null, i-1);
          }
        }
        window.location.reload();
      } catch (err) {
        window.location.reload();
      }
    }
  }

  goTo = (route) => {
    this.props.history.push(`/${route}`);
  }

  confirmDeactivate = (theList) => {

    //this no longer applies since we switched to payment rails.  Leaving for now....
    /*let purpose = 0;
    if (this.props.purpose === 0 || this.props.purpose === 1 ) {
      purpose = this.props.purpose;
    }

    let ps1 = theList[this.state.rowMenuClicked];
    if (ps1.psType === 1) {
      //since this is ach, make sure status on the other side is suspended.
      if (ps1.psStatusOther === 0) {
        let message = '';
        if (purpose === 0) {
          message = ps1.achAccountNum + ' is also used to receive rebate and markup payments.  If you want to remove this payment source, please suspend it on the "receive commissions" tab.';
        } else {
          message =  ps1.achAccountNum + ' is also used to make payments into AppBind.  If you want to remove this payment source, please suspend it on the "pay for my subscriptions" tab.';

        }
        this.setState({snackbarOpen: true, saveStatus: 'error', saveMessage: message, activeMenu: null, deactiveMenu: null});
        return;
      }
    }*/

    this.setState({confirmDeactivate: true, activeList: theList, activeMenu: null, deactiveMenu: null});
  };

  async deactivate() {
    const { callPartnerApi } = this.props.auth;
    
    let purpose = 0;
    if (this.props.purpose === 0 || this.props.purpose === 1 ) {
      purpose = this.props.purpose;
    }

    let ps1 = this.state.activeList[this.state.rowMenuClicked];
    let activeList = this.state.activeList;
    let deactivateIndex = this.state.rowMenuClicked;

    if (ps1 == null) {
      // alert('Cannot suspend');
    } else {
      let doDeactivate = true;
 
      //if no activity on funding source, it can be deleted from database.
      let deleteFundingSource = false;
      if (!ps1.paidLifetime) {
        deleteFundingSource = true;
      } 

      try {
        // If credit card, call Stripe to remove source
        // If ach, call Dwolla to remove source
        if (ps1.psType === 0) {
          // Credit card
          if (ps1.extSource === 'stripe' && this.uInfo != null && this.uInfo.stripeCid != null) {
            let extPsId = ps1.extPsId;
            let payload = {
              operation: "deleteStripeSource",
              params: {
                stripeCustomerId: this.uInfo.stripeCid,
                stripeSourceId: extPsId
              }
            };
            let dresp = await callPartnerApi('appbind/generic', 'POST', payload);
          } else {
            doDeactivate = false;
          }
        } else if (ps1.psType === 1) {
          // ACH
          if (ps1.extSource === 'dwolla') {
            let extPsId = ps1.extPsId;
            // Call API to remove
            let payload = {
              operation: "removeDwollaSource",
              params: {
                fundingSourceId: extPsId
              }
            };
            let dresp = await callPartnerApi('appbind/generic', 'POST', payload);
          } else {
            doDeactivate = false;
          }
        } else if (ps1.psType === 2) {
          //nothing really to do here.
        } 

        if (doDeactivate) {
          let fromStatus = ps1.psStatus;
          if (!deleteFundingSource) {
            let psum = await PaymentSourceUpdateMutation.commit(ps1.psId, 2, null);

          } else {
            let psId = await PaymentSourceDeleteMutation.commit(ps1.psId);
          }
          // Only change order if this was in the active list
          if (fromStatus === 0) {
            for (let i= deactivateIndex + 1; i < activeList.length; i++) {
              let aPs = activeList[i];
              if (purpose === 0) {
                let aPsum = await PaymentSourceUpdateMutation.commit(aPs.psId, null, i-1, null, null);
              } else {
                let aPsum = await PaymentSourceUpdateMutation.commit(aPs.psId, null, null, null, i-1);
              }
            }
          }
         window.location.reload();
        }
      } catch (err) {
        window.location.reload();
      }
    }
  }

  unsuspend(theInactives, theActives) {

    let purpose = 0;
    if (this.props.purpose === 0 || this.props.purpose === 1 ) {
      purpose = this.props.purpose;
    }

    let idx = this.state.rowMenuClicked;
    let ps1 = theInactives[idx];
    if (ps1 == null) {
      // alert('Cannot unsuspend');
    } else {
      Promise.resolve()
      .then(() => {
        if (purpose === 0) {
          return PaymentSourceUpdateMutation.commit(ps1.psId, 0, theActives.length, null, null);
        } else {
          return PaymentSourceUpdateMutation.commit(ps1.psId, null, null, 0, theActives.length);
        }
      })
      .then(resp => {
        window.location.reload();
      })
      .catch(err => {
        window.location.reload();
      });
    }
  }

  updateAccountMissingFields = (acctId, nextDialog) => {
    const { address1, address2, city, state, country, postalCode, addressFilled,
        contactFirstName, contactLastName, contactEmail, primaryContactFilled } = this.state;

    if (nextDialog === "CC") {
      this.setState({showCCSpinner: true});
    } else if (nextDialog === "ACH") {
      this.setState({showACHSpinner: true});
    } 

    let accountUpdatePromise = null;
    if (addressFilled && primaryContactFilled) { //resolved promise, these are already filled, so don't update
      accountUpdatePromise = Promise.resolve();
    } else if (!addressFilled && primaryContactFilled) { //only address update
      accountUpdatePromise = AccountUpdateMutation.commit(acctId, null, null, null, null,
        null, null, null, null,
        address1, address2, city, state, country, postalCode,
        null, null, null, null, null, 
        null, null, null);
    } else if (addressFilled && !primaryContactFilled) { //only contact update
      accountUpdatePromise = AccountUpdateMutation.commit(acctId, null, null, null, null,
        contactLastName, contactFirstName, contactEmail, null,
        null, null, null, null, null, null,
        null, null, null, null, null, 
        null, null, null);
    } else { //both address and contact update.
      accountUpdatePromise = AccountUpdateMutation.commit(acctId, null, null, null, null,
        contactLastName, contactFirstName, contactEmail, null,
        address1, address2, city, state, country, postalCode,
        null, null, null, null, null, 
        null, null, null);
    }

    accountUpdatePromise.then(response => {
      // console.log('Account updated')
      if (nextDialog === "CC") {
        localStorage.setItem("buttonClick", "CC");
      } else if (nextDialog === "ACH") { 
        localStorage.setItem("buttonClick", "ACH");
      } 

      if (acctId === abEnvironment.getUserAttribute("a_id")) {

        //if user is updating their own, set their local storage.
        if (!addressFilled) {
          abEnvironment.setUserAttribute('a_address1', address1);
          if (address2 != null) {
            abEnvironment.setUserAttribute('a_address2', address2);
          }
          abEnvironment.setUserAttribute('a_city', city);
          abEnvironment.setUserAttribute('a_state', state);
          abEnvironment.setUserAttribute('a_country', country);
          abEnvironment.setUserAttribute('a_postalCode', postalCode);
        }
        if (!primaryContactFilled) {
          abEnvironment.setUserAttribute('a_firstName', contactFirstName);
          abEnvironment.setUserAttribute('a_lastName', contactLastName);
          abEnvironment.setUserAttribute('a_email', contactEmail);
        }
      }

      window.location.reload();
    })
    .catch(error => {
      // console.log('Got error: ' + error);
    });
  }

  componentDidMount() {
 
      const { logError } = this.props.auth;

      //this query is dual purpose. For unauthenticated customers, it gets their reseller name
      //for ALL it tests whether their account has an address by checking address1 field.
      let accountId = this.props.accountId
      
      var buttonClick = localStorage.getItem("buttonClick");
      localStorage.removeItem("buttonClick");

      AccountInformationFetch.fetch(accountId).toPromise()
      .then(aif => {
          var addressFilled = false;
          if (aif.accountTByAccountId.address1 !== null && aif.accountTByAccountId.address1 !== '') {
            addressFilled = true;
          }

          var primaryContactFilled = false;
          if (aif.accountTByAccountId.contactFirstName !== null && aif.accountTByAccountId.contactFirstName !== ''
                && aif.accountTByAccountId.contactLastName !== null && aif.accountTByAccountId.contactLastName !== '') {
            primaryContactFilled = true;
          }

          var resellerName = "";
          if (this.props.auth.isUnauthenticatedCustomer()) {
            resellerName = aif.accountTByAccountId.accountTByParentId.accountName;
          }

          if (buttonClick && buttonClick === "CC") {
            this.setState({ccOpen: true});
          } else if (buttonClick && buttonClick === "ACH") {
            this.setState({achOpen: true});
          } 
          this.setState({
            accountFetched: true,
            resellerName: resellerName,
            addressFilled: addressFilled,
            primaryContactFilled: primaryContactFilled
          });    
      })
      .catch(err => {
        logError('Exception in FundingSourceList.js: ' + err);
      })
  }

  setDwollaCidOnUInfo = (dwollaCid) => {
    this.uInfo.dwollaCid = dwollaCid;
  }

  setStripeCidOnUInfo = (stripeCid) => {
    this.uInfo.stripeCid = stripeCid;
  }

  /*
   * Invite a (customer) user to put a funding source on file to pay for the subscription.
   * This method will be passed to an invite component.
   */
  inviteCustomerUser = (bcUser) => {
    // If the user already exists, send them to the user edit to invite using that current user.
    // Otherwise, send to create.
    if (bcUser.userid != null && bcUser.userid !== '') {
      let link = 'useredit?userId=' + bcUser.userid + '&accountId=' + bcUser.accountId;
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription manage (inviting existing customer user)'); }
      this.props.history.push(link);
    } else {
      let propsToCache = {'contactLastName'  : bcUser.lastname,
                          'contactFirstName' : bcUser.firstname,
                          'contactEmail'     : bcUser.email};
      localStorage.setItem('userCreateParamProps', JSON.stringify(propsToCache));
      let link = 'usercreate?accountId=' + bcUser.accountId;
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription manage (inviting new customer user)'); }
      this.props.history.push(link);
    }
  }

  /*
   * Reinvite a customer user to put a funding source on file to pay for the subscription.
   * This method will be passed to an invite component.
   */
  reinviteCustomerUser = (bcUser) => {
    let link = 'useredit?userId=' + bcUser.userid + '&accountId=' + bcUser.accountId;
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription manage (inviting existing customer user)'); }
    this.props.history.push(link);
  }

  getValueForDepositRender(idx, lidx) {
    if (this.state.microdeposits == null) {
      return 0;
    }

    // Index is 1 based, so decrement
    let zidx = idx - 1;
    
    if (zidx >= this.state.microdeposits.length) {
      return 0;
    }

    let depositEntry = this.state.microdeposits[zidx][lidx];
    if (depositEntry == null) {
      return 0;
    }

    return depositEntry;
  }

  setDepositValue(idx, lidx, value) {
    let microdeposits = [];
    let zidx = idx-1;

    let newSourceEntry = [0, 0];
    if (lidx === 0) {
      newSourceEntry = [value, 0];
    } else if (lidx === 1) {
      newSourceEntry = [0, value];
    }

    if (this.state.microdeposits == null) {
      for (let i=0; i<idx; i++) {
        if (i+1<idx) {
          let isourceEntry = [0, 0];
          microdeposits.push(isourceEntry);
        } else {
          microdeposits.push(newSourceEntry);
        }
      }
    } else {
      /*
         Say we have [ [0.05,0.07] ]
         But idx=2, lidx=1, value = 0.09
         So want outcome to be
         [ [0.05,0.07], [0,0.09]]
      */
      microdeposits = this.state.microdeposits;
      if (microdeposits.length < idx) {
        for (let ci=microdeposits.length; ci<idx; ci++) {
          if (ci+1<idx) {
            let isourceEntry = [0, 0];
            microdeposits.push(isourceEntry);
          } else {
            microdeposits.push(newSourceEntry);  
          }
        }
      } else {
        let sourceEntry = microdeposits[zidx];
        sourceEntry[lidx] = value;
      }
    }

    this.setState({ microdeposits: microdeposits });
  }

  async verifyDepositAmounts(psId, deposit1, deposit2) {

    this.setState({status: 'verifying'});

    const { callPartnerApi } = this.props.auth;

    let payload = {
      operation: "verifyDwollaMicrodeposits",
      params: {
        psId:     psId,
        deposit1: deposit1,
        deposit2: deposit2
      }
    };

    try {
      let vresp = await callPartnerApi('appbind/generic', 'POST', payload);
      this.setState({status: ''});
      window.location.reload();
    } catch (err) {
      this.setState({status: ''});
      window.location.reload();
    }
  }

  verifyDepositAmountsPlaid(psId, plaidAccessToken, plaidItemId, plaidAccountId, plaidManualVerify) {

    //console.log('setting state Plaid: '+ plaidAccessToken);

    this.setState({accessToken: plaidAccessToken, showPlaidMicro: true})

  }


  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  isACHAllowed(uInfo) {
    if (uInfo.achActive === "0") {
      return false;
    }

    if ((uInfo.firstName === null) || (uInfo.lastName === null) || (uInfo.email === null)) {
      return false;
    }
    return true;
  }

  isAccountMissingFieldsComplete() {
    return (this.state.addressFilled || this.isAddressComplete()) && (this.state.primaryContactFilled || this.isPrimaryContactComplete()); 
  }

  isAddressComplete() {
    if (this.state.address1 !== '' && this.state.city !== '' && this.state.state !== '' && this.state.country !== ''  && this.state.postalCode !== '') {
      return true;
    }

    return false;
  }

  isPrimaryContactComplete() {
    if (this.state.contactFirstName !== '' && this.state.contactLastName !== '' && this.state.contactEmail !== '' && this.state.contactEmailValid) {
      return true;
    }

    return false;
  }

  render() {
    const classes = this.props.classes;
    const okColor = green[300];
    const redColor = red[600];
    const yellowColor = yellow[600];
    
    const { validateEmail, isVirtualMasquerade, isUnauthenticatedCustomer, isAuthenticatedCustomer, isAuthenticatedReseller, isAuthenticatedVendor, logError } = this.props.auth;

    // The funding source list is either on the my funding page, or the customer page.
    // If the user info object is passed in, this is the customer page, so use that object.
    // If it isn't passed in, use the account contact convenience function for the current
    // using account.

    // The funding source list is shown on the my funding page for all user types:
    // - Unauthenticated Customer
    // - Authenticated Customer
    // - Reseller
    // - Vendor
    //
    // The cp property indicates the calling page
    // - vendor:    called from the admin console vendor page
    // - reseller:  called from the admin console reseller page
    // - customer:  called from the reseller customer page, and the admin console customer page.  (Same page - need to be careful)
    // - myfunding: called from the my funding page for all personas.
    // 
    // The uinfo property indicates the user that this source is being added for.  This is passed in the
    // vendor, reseller, and customer cases, as the source is being added for that vendor, reseller, or customer.
    //
    // If uinfo is not passed in, this is "my funding" (funding for the current user).
    // 

    let cp = this.props.cp;
    let acctId = this.props.accountId;

    // Rendering settings
    let headerText           = null;
    let summaryText          = null;

    let showInviteButton     = false;
    let inviteButtonDisabled = true;

    let showAchButton        = false;
    let achButtonDisabled    = true;
    let achButtonVariant     = 'outlined';

    let showCCButton         = false;
    let ccButtonDisabled     = true;
    let ccButtonVariant      = 'outlined';
    let ccTooltip            = null;

    //
    // Use the current user if on the my funding page.
    // 
    let resellerViewingCustomerRestricted = false;
    if (cp === 'myfunding') {
      this.uInfo = abEnvironment.getAccountContact();
    } else {
      // Use the passed user.  uInfo must be set; if not, we won't show any buttons.
      this.uInfo = this.props.uInfo;


      try {
        let rUseBudgets = Number.parseInt(abEnvironment.getUserAttribute('a_useBudgets'));
        if (rUseBudgets === 2) {
          resellerViewingCustomerRestricted = true;
        }
      } catch (nErr) {
        // Swallow
      }
    }

    // 0 means payments out, 1 means payments in
    let purpose = 0;
    if (this.props.purpose === 0 || this.props.purpose === 1 ) {
      purpose = this.props.purpose;
    }

    // Expensing - only show add buttons if expensing is active.
    let expensingActive = false;
    let expensing = abEnvironment.getFlagValue("expensing");
    if (expensing != null && expensing.flagValue === 1) {
      expensingActive = true;
    }          

    //
    // Text, button settings
    //
    let thFunding = "Funding source";
    let thPtm = "Paid this month";
    let thPlm = "Paid last month";
    let thPytd = "Paid this year";

    if (cp === 'myfunding') {
      if (isUnauthenticatedCustomer()) {
        if (expensingActive === true) {
          headerText = 'Connect your funding sources';
          showCCButton = true;

          if (this.isACHAllowed(this.uInfo)) {
            showAchButton = true;
            achButtonVariant = 'contained';
          } else {
            ccButtonVariant = 'contained';
          }  
        } else {
          headerText = 'View your funding sources';
          showCCButton = false;
          showAchButton = false;
        }
        summaryText = 'Funding sources are used to fund your expense wallet, and to pay for services provided by ' +  this.state.resellerName + '.';
      } else if (isAuthenticatedCustomer ()) {
        if (expensingActive === true) {
          headerText = 'Connect your funding sources';
          showCCButton = true;

          if (this.isACHAllowed(this.uInfo)) {
            showAchButton = true;
            achButtonVariant = 'contained';
          } else {
            ccButtonVariant = 'contained';
          }
        } else {
          headerText = 'View your funding sources';
          showCCButton = false;
          showAchButton = false;
        }
        summaryText = 'Funding sources are used to pay for subscriptions purchased with AppBind.';
      } else if (isAuthenticatedReseller ()) {
        if (expensingActive === true) {
          headerText = 'Connect your funding sources';

          if (purpose === 1) {
            headerText = 'Connect your payout accounts';
            summaryText = 'Payout accounts receive rebate and commission payouts.';
            thFunding = "Payout account";
            thPtm = "Payout this month";
            thPlm = "Payout last month";
            thPytd = "Payout this year";
          }
  
          if (this.props.purpose === 0) {
            showCCButton = true;
          } else {
            showCCButton = false;
          }
  
          if (this.isACHAllowed(this.uInfo)) {
            showAchButton = true;
            achButtonVariant = 'contained';
          } else {
            ccButtonVariant = 'contained';
          }
  
        } else {
          headerText = 'View your funding sources';
          showCCButton = false;
          showAchButton = false;
        }

        summaryText = 'Funding sources are used to pay for subscriptions purchased with AppBind.';

      } else if (isAuthenticatedVendor ()) {
        headerText = 'Connect your funding sources';
        summaryText = 'Funding sources are used to pay for rebate programs.';
        if (purpose === 1) {
          headerText = 'Connect your payout accounts';
          summaryText = 'Payout accounts receive payment for prepaid licenses.';
          thFunding = "Payout account";
          thPtm = "Payout this month";
          thPlm = "Payout last month";
          thPytd = "Payout this year";
        }

        // If masquerading with a virtual user, buttons should not be available
        if (! isVirtualMasquerade()) {
          if (this.props.purpose === 0) {
            showCCButton = true;
          } else {
            showCCButton = false;

          }
        
          if (this.isACHAllowed(this.uInfo)) {
            showAchButton = true;
            achButtonVariant = 'contained';
          } else {
            ccButtonVariant = 'contained';
          }
        }
      }
    } else if (cp === 'vendor') {
      headerText = "Vendor funding sources";
      summaryText = "Vendor funding sources are used to pay for reseller rebate programs and to accept payment for prepaid licenses.";                
    } else if (cp === 'reseller') {
      headerText = "Reseller funding sources";
      summaryText = "Reseller funding sources are used to pay for subscriptions and to accept commission payouts.";                
    } else if (cp === 'customer') {
      if (isAuthenticatedReseller()) {

        if (resellerViewingCustomerRestricted || expensingActive === false) {
          headerText = "Customer funding sources";
          summaryText = "Funding sources are used to pay for subscriptions and services purchased with AppBind.";  
          showCCButton = false;
  
        } else {
          headerText = "Connect your customer's funding sources";
          summaryText = "Funding sources are used to pay for subscriptions and services purchased with AppBind.";  
          showCCButton = true;
           
        }
 
        // Invite button handling
        if (this.props.anyUserInvite === true && expensingActive === false) {
          showInviteButton = true;
          ccTooltip = 'If you already have a funding source for your customer, you can add it for them';
        } else {
          ccButtonVariant = 'contained';
        }
      } else {
        headerText = "Customer funding sources";
        summaryText = "Funding sources are used to pay for customer subscriptions purchased with AppBind.";  
      }           
    }

    var billingAddressInstructions = "";
    if ((cp === 'customer') && isAuthenticatedReseller()) {
      billingAddressInstructions = "Please enter your customer's billing address";
    } else {
      billingAddressInstructions = "Please enter your billing address";
    }

    // Buttons are disabled if the account or resellers account is suspended or we're in the process of verifying microdeposits
    let disableAdd = false;
    if (this.props.accountStatus === 1 || this.props.accountStatus === 2) {
      disableAdd = true;
    }
    if (this.props.resellerStatus && (this.props.resellerStatus === 1 || this.props.resellerStatus === 2)) {
      disableAdd = true;
    }

    if (disableAdd === true || this.state.status === "verifying") {
      achButtonDisabled    = true;
      ccButtonDisabled     = true;
      inviteButtonDisabled = true;
    } else {
      achButtonDisabled    = false;
      ccButtonDisabled     = false;
      inviteButtonDisabled = false;
    }

    // This is only relevant if the invite button is visible
    let who = this.uInfo.accountName;
    if (! who) {
      who = 'your customer';
    }
    let whott = 'Invite your customer to AppBind so that they can add a funding source to pay for subscriptions you manage for them';

    let queryForActiveOnly = 0;  // This used to be based on state

    //in case we need to capture billing address
    let address = {
      country:    this.state.country,
      state:      this.state.state,
      city:       this.state.city,
      postalCode: this.state.postalCode,
      address1:   this.state.address1,
      address2:   this.state.address2
    };

    var subscriptionReturn = localStorage.getItem('subscriptionReturn');
    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={FundingSourceListQuery}
        variables={{accountId: acctId,
                    activeOnly: queryForActiveOnly,
                    purpose: purpose}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            let accountCancelled = false;
            if (props.accountTByAccountId.accountStatus === 3) {
              accountCancelled = true;
            }
            let paymentSourceCount = 0;
            if (props.paymentsourceswithaggregate7 != null && props.paymentsourceswithaggregate7.totalCount > 0) {
              //there is a header row that we do not want counted as a payment source.
              paymentSourceCount = props.paymentsourceswithaggregate7.totalCount - 1;
            }

            if (!this.state.accountFetched) { 

              return (
                <div>
                  <LoadingSpinner/>
                </div>
              );

            } else if (this.props.accountStatus === 1 || this.props.accountStatus === 2) {

              return (
                <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                  <Grid item xs={12}>
                    <Grid container spacing={0} direction="column" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="h6">{headerText}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">{summaryText}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {this.props.accountStatus === 1 &&
                    <Grid item  xs={12}> 
                      <Typography variant="body2">Account has been suspended.</Typography>
                    </Grid>
                  }
                  {this.props.accountStatus === 2 &&
                    <React.Fragment>
                      <Grid item  xs={12}> 
                        <Typography variant="body2">In order for you to connect a bank account or credit card, we need to know you a bit better. You can use a government id to verify your identity in less than five minutes!</Typography>
                      </Grid>

                      <Grid item  xs={12}> 
                        <Button color="primary" 
                                variant={achButtonVariant}
                                onClick={() => { this.goTo('home');}}>
                            Verify account
                        </Button>
                      </Grid>
                    </React.Fragment>
                  }


                </Grid>
              );

            } else if (!this.state.addressFilled || !this.state.primaryContactFilled) {

              return (
                <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                  <Grid item xs={12}>
                    <Grid container spacing={0} direction="column" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="h6">{headerText}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">{summaryText}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  { !this.state.primaryContactFilled &&
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6" className={classes.sectionTitle}>
                          Insert primary contact information required for billing sources
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                          id="first-name" label="Contact first name"
                          value={ this.state.contactFirstName }
                          onChange={ (e) => this.setState({ contactFirstName: e.target.value }) }
                          inputProps={{ maxLength: 32 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                          id="last-name" label="Contact last name"
                          value={ this.state.contactLastName }
                          onChange={ (e) => this.setState({ contactLastName: e.target.value }) }
                          inputProps={{ maxLength: 32 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                          id="email" label="Contact email"
                          error={this.state.contactEmailValid != null && !this.state.contactEmailValid}
                          value={ this.state.contactEmail }
                          type='email'
                          onChange={ (e) => {
                            let newValue = e.target.value; 
                            let emailValidCheck = validateEmail(newValue);
                            this.setState({
                              contactEmail: e.target.value,
                              contactEmailValid: emailValidCheck
                            });
                          }}
                          inputProps={{ maxLength: 254 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {/* remove this grid item when we bring phone number back */}
                      </Grid>
                    </>
                  }
                  { !this.state.addressFilled && !resellerViewingCustomerRestricted &&
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6" className={classes.sectionTitle}>
                          {billingAddressInstructions}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{marginBottom: 16}}>
                        <Address
                          showRequired={false}
                          address={address}
                          regionLabel={"Region"}
                          setCountryCodeState={this.setCountry}
                          setRegionCodeState={this.setRegion}
                          setCityState={this.setCity}
                          setPostalCodeState={this.setPostalCode}
                          setAddress1State={this.setAddress1}
                          setAddress2State={this.setAddress2}
                        />
                      </Grid>
                    </>
                  }
                  <Grid item  xs={12}>
                    <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                      { showAchButton && !this.state.showACHSpinner &&
                      <Grid item > 
                        <Button color="primary" 
                                variant={achButtonVariant}
                                disabled={!this.isAccountMissingFieldsComplete() || achButtonDisabled || accountCancelled} 
                                onClick={() => { this.updateAccountMissingFields(acctId,"ACH");}}>
                            <Add/> Add US Bank Account (ACH)
                        </Button>
                      </Grid>
                      }
                      { showAchButton && this.state.showACHSpinner &&
                      <Grid item > 
                        <Button disabled={false} color="primary" variant={achButtonVariant} >
                          <SavingSpinner/>
                        </Button>
                      </Grid>
                      }
                      { showCCButton && ccTooltip != null && !this.state.showCCSpinner &&
                      <Grid item > 
                        <Tooltip title={ccTooltip}>
                          <Button color="primary" 
                                  variant={ccButtonVariant}
                                  disabled={!this.isAccountMissingFieldsComplete()  || accountCancelled} 
                                  onClick={() => { this.updateAccountMissingFields(acctId,"CC");}}>
                          <Add/> Add Credit Card
                          </Button>
                        </Tooltip>
                      </Grid>
                      }
                      { showCCButton && ccTooltip == null && !this.state.showCCSpinner &&
                      <Grid item > 
                        <Button color="primary" 
                                variant={ccButtonVariant}
                                disabled={!this.isAccountMissingFieldsComplete() || ccButtonDisabled  || accountCancelled} 
                                onClick={() => { this.updateAccountMissingFields(acctId,"CC");}}>
                                <Add/> Add Credit Card
                        </Button>
                      </Grid>
                      }
                      { showCCButton && this.state.showCCSpinner &&
                      <Grid item > 
                        <Button disabled={false} color="primary" variant={ccButtonVariant} >
                          <SavingSpinner/>
                        </Button>
                      </Grid>
                      }
                    </Grid>
                  </Grid>

                </Grid>

                
              );
            } else if (subscriptionReturn && paymentSourceCount !== 0) {
              //this can happen after ACH addition because it does a window reload.
              var subscriptionLink = '/subscription?customerAppId=' + subscriptionReturn + '&fp=Funding';
              localStorage.removeItem('subscriptionReturn');
              return (<Redirect push to={subscriptionLink} />);
            } else {

            
              // Iterate through sources to sum totals
              let sumMtd = 0; // Month to date
              let sumLm  = 0; // Last month
              let sumYtd = 0; // Year to date

              // Are there records, should be at least a header row?
              let maxPsOrder = 0;
              let maxPsOrderIn = 0;
              if (props.paymentsourceswithaggregate7 != null && props.paymentsourceswithaggregate7.totalCount > 0) {
                //header row is returned with count first
                maxPsOrder = props.paymentsourceswithaggregate7.nodes[0].maxPsOrder;
                if (maxPsOrder === -1) {
                  maxPsOrder = 0;
                } else {
                  maxPsOrder++;
                }
                
                maxPsOrderIn = props.paymentsourceswithaggregate7.nodes[0].maxPsOrderIn;
                if (maxPsOrderIn === -1) {
                  maxPsOrderIn = 0;
                } else {
                  maxPsOrderIn++;
                }

              }

              var pendings = [];
              var errors = [];
              var actives = [];
              var inactives = [];

              if (paymentSourceCount) {
                //this starts at 1 because there is a header row
                for (var i=1; i<props.paymentsourceswithaggregate7.nodes.length; i++) {
                  let n = props.paymentsourceswithaggregate7.nodes[i];

                  if (n.psStatus === 0) {
                    sumMtd = sumMtd + Number(n.paidMtd);
                    sumLm  = sumLm  + Number(n.paidLastMonth);
                    sumYtd = sumYtd + Number(n.paidYtd);
                    actives.push(n);
                  } else {
                    if (this.state.activeOnly !== 1) {
                      sumMtd = sumMtd + Number(n.paidMtd);
                      sumLm  = sumLm  + Number(n.paidLastMonth);
                      sumYtd = sumYtd + Number(n.paidYtd);  

                      if (n.psStatus === 1 || n.psStatus === 2) {
                        inactives.push(n);
                      } else if (n.psStatus === 3) {
                        errors.push(n);
                      } else if (n.psStatus > 3 && n.psStatus < 10) {
                        pendings.push(n);
                      }
                    }
                  }
                }
              }
              let mtdSum = Number(sumMtd)
              .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let lmSum = Number(sumLm)
              .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let ytdSum = Number(sumYtd)
              .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

              var aCount = 0;
              var iCount = 0;

              //console.log('total=' + paymentSourceCount);
              //console.log('active=' + actives.length);
              let pendingsDepCount = 0;

              return (
                <div>
                    <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                      <Grid item xs={12}>
                        <Grid container spacing={0} direction="column" justifyContent="flex-start">
                          <Grid item>
                            <Typography variant="h6">{headerText}</Typography>
                          </Grid>
                          <Grid item>
                            <Typography variant="body2">{summaryText}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* Invite button if appropriate
                        *  On customer page, no user, pending subscriptions.  
                      */}
                      { showInviteButton &&
                      <Grid item > 
                        <InviteCustomerButton buttonType={false}
                                              disabled={inviteButtonDisabled} 
                                              auth={this.props.auth}
                                              accountId={acctId} 
                                              whoInvite={who}
                                              whoTooltip = {whott}
                                              reInvite={this.reinviteCustomerUser} 
                                              invite={this.inviteCustomerUser}/>
                      </Grid>
                      }
                      { showAchButton &&
                      <Grid item > 
                        <Button color="primary" 
                                variant={achButtonVariant}
                                disabled={achButtonDisabled  || accountCancelled} 
                                onClick={this.openACHDialog}>
                          <Add/> Add US Bank Account (ACH)
                        </Button>
                      </Grid>
                      }
                      { showCCButton && ccTooltip != null &&
                      <Grid item > 
                        <Tooltip title={ccTooltip}>
                          <Button color="primary" 
                                  variant={ccButtonVariant}
                                  disabled={ccButtonDisabled  || accountCancelled} 
                                  onClick={this.openCCDialog}>
                            <Add/> Add Credit Card
                          </Button>
                        </Tooltip>
                      </Grid>
                      }
                      { showCCButton && ccTooltip == null &&
                      <Grid item > 
                        <Button color="primary" 
                                variant={ccButtonVariant}
                                disabled={ccButtonDisabled || accountCancelled} 
                                onClick={this.openCCDialog}>
                          <Add/> Add Credit Card
                        </Button>
                      </Grid>
                      }
                    </Grid>
                      
                    {(actives.length > 0 || pendings.length > 0 || inactives.length > 0 || errors.length > 0) &&
                    <div className={classes.paper}>
                    <Grid container spacing={1} justifyContent="center" className={classes.sectionBlock}>      
                      <Grid item xs={12}>
                        {/*<FormControlLabel
                          control={
                            <Switch
                              checked={this.state.activeOnly === 1}
                              disabled={this.state.status === "verifying"}
                              onChange={(e, checked) => {
                                if (checked) {
                                  this.setState({ activeOnly: 1});
                                } else {
                                  this.setState({ activeOnly: 0});
                                }
                              }}
                            />
                          }
                          label={onlyShowActive}
                        />*/}
                      </Grid>
                    </Grid>

                    {pendings.length > 0 &&
                    <React.Fragment>
                    <TableContainer>
                      <Table>
                        <TableHead className={classes.tblHead}>
                          <TableRow className={classes.tblHeadRow}>
                            <TableCell className={classes.tblHeadCell}>Pending source</TableCell>
                            <TableCell className={classes.tblHeadCell}>Instructions</TableCell>
                            <TableCell className={classes.tblHeadCellN}>Status</TableCell>
                            <TableCell className={classes.tblHeadCellN}></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        { pendings.map (n => {
                            /* Microdeposit flow */
                            let dep1_label = 'dep1';
                            let dep2_label = 'dep2';
                            let curCount = 1;
                            let thePsId = null;
                            let dep1_value = null;
                            let dep2_value = null;
                            let verifyDisabled = true;
                
                            if (n.psStatus === 6 || n.psStatus === 8) {
                              pendingsDepCount = pendingsDepCount + 1;
                              dep1_label = 'dep1_' + pendingsDepCount;
                              dep2_label = 'dep2_' + pendingsDepCount;
                              curCount = pendingsDepCount;
                              thePsId = n.psId;
                              dep1_value = this.getValueForDepositRender(curCount, 0);
                              dep2_value = this.getValueForDepositRender(curCount, 1);

                              if (dep1_value > 0 && dep2_value > 0) {
                                verifyDisabled = false;
                              }
                            }
                            return (
                              <TableRow key={n.psId}>
                                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellAppCol}>
                                  <FundingSourceTile 
                                    psType={n.psType}
                                    ccBrand={n.ccBrand}
                                    ccLast4={n.ccLast4}
                                    ccExpy={n.ccExpy}
                                    fiName={n.fiName}
                                    achAccountNum={n.achAccountNum}
                                    firstName={n.firstName}
                                    lastName={n.lastName}
                                    paypalEmail={n.paypalEmail}
                                    extPsId={n.extPsId}
                                  />
                                </TableCell>
                                <TableCell>
                                  {/* 4: Pending state - waiting for funding source to be setup */}
                                  {n.psStatus === 4 && (n.plaidManualVerify === 0) &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Connecting to your bank account
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          A connection to your account is being established.  You'll be notified when your account is verified, or if you need to take
                                          further steps to verify your account.
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 4 && (n.plaidManualVerify === 1) &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Connecting to your bank account
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          A connection to your account is being established.  Please look in your account for 2 microdeposits
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {/* 4: Pending state - waiting for microdeposits to be made */}
                                  {n.psStatus === 5 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Waiting for microdeposits
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          To verify your bank account information, two deposits of 10 cents or less have been initiated via ACH transfer.
                                          When these deposits have completed, you'll be notified so that you can enter the deposit amounts here to verify your account.
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 6 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Enter microdeposits
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          To verify your account, please enter the amounts of the two recent microdeposits from AppBind Inc.
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Grid container spacing={1} justifyContent="space-around">
                                          <Grid item>
                                            <TextField
                                              id={dep1_label} label="Deposit 1" 
                                              value={ dep1_value }
                                              disabled={this.state.status === 'verifying'}
                                              onChange={ (e) => this.setDepositValue(curCount, 0,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            <TextField
                                              id={dep2_label} label="Deposit 2" 
                                              value={ dep2_value }
                                              disabled={this.state.status === 'verifying'}
                                              onChange={ (e) => this.setDepositValue(curCount, 1,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            {this.state.status !== 'verifying' &&
                                            <Button color="primary" variant="outlined" 
                                                    disabled={verifyDisabled}
                                                    onClick={() => {this.verifyDepositAmounts(thePsId, 
                                                      this.getValueForDepositRender(curCount, 0),
                                                      this.getValueForDepositRender(curCount, 1))}}>
                                              Verify 
                                            </Button>
                                            }
                                            {this.state.status === 'verifying' &&
                                            <Button color="primary" variant="outlined" >
                                              <SavingSpinner/> 
                                            </Button>
                                            }
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 7 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Waiting for account verification to complete
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          As soon as account verification is completed, your bank account will be an active funding source for AppBind. 
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 8 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Re-enter microdeposits
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          The values you entered previously did not match the microdeposits made to your account.  Please check your account, and try again.
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Grid container spacing={1} justifyContent="space-around">
                                          <Grid item>
                                            <TextField
                                              id={dep1_label} label="Deposit 1" 
                                              value={ dep1_value }
                                              disabled={this.state.status === 'verifying'}
                                              onChange={ (e) => this.setDepositValue(curCount, 0,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            <TextField
                                              id={dep2_label} label="Deposit 2" 
                                              value={ dep2_value }
                                              disabled={this.state.status === 'verifying'}
                                              onChange={ (e) => this.setDepositValue(curCount, 1,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            {this.state.status !== 'verifying' &&
                                            <Button color="primary" variant="outlined" 
                                                    disabled={verifyDisabled}
                                                    onClick={() => {this.verifyDepositAmounts(thePsId, 
                                                      this.getValueForDepositRender(curCount, 0),
                                                      this.getValueForDepositRender(curCount, 1))}}>
                                              Verify 
                                            </Button>
                                            }
                                            {this.state.status === 'verifying' &&
                                            <Button color="primary" variant="outlined" >
                                              <SavingSpinner/> 
                                            </Button>
                                            }
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 9 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Unable to verify this account
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          This account could not be verified.  Please contact AppBind support for assistance.
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                </TableCell>
                                <TableCell align="center">
                                  {/* 4: Pending state - initiation of verification */}
                                  {n.psStatus === 4 &&
                                    <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                  }
                                  {/* 5: Pending state - waiting for microdeposits to be made */}
                                  {n.psStatus === 5 &&
                                    <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                  }
                                  {/* 6: Pending state - microdeposits have been made, now need user to verify */}
                                  {n.psStatus === 6 &&
                                    <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                  }
                                  {/* 7: Pending state - waiting for verification from Dwolla */}
                                  {n.psStatus === 7 &&
                                    <HourglassEmpty htmlColor={okColor} className={classes.nonMenuStatus}/>
                                  }
                                  {/* 8: Verification failed, user can retry verification */}
                                  {n.psStatus === 8 &&
                                    <HourglassEmpty htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                  {/* 9: Verification failed, user must restart the process - this source should
                                        be removed */}
                                  {n.psStatus === 9 &&
                                    <HourglassEmpty htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                  {n.psStatus === 3 &&
                                    <ErrorOutline htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                </TableCell>
                                <TableCell align="center">
                                  {n.psStatus === 4 && (n.plaidManualVerify === 1) &&
                                    <Button color="primary" variant="outlined" 
                                          disabled={false}
                                          onClick={() => {this.verifyDepositAmountsPlaid(n.psId, n.plaidAccessToken, n.plaidItemId, n.plaidAccountId, n.plaidManualVerify)}}>
                                     Verify
                                  </Button>                                
                                  }

                                </TableCell>
                              </TableRow>
                            );
                          })}

                        </TableBody>
                      </Table>
                    </TableContainer>
                    </React.Fragment>
                    }

                    {pendings.length > 0 &&
                    <div className="divider">
                      &nbsp;
                    </div>
                    }
                    <TableContainer>
                      <Table>
                        <TableHead className={classes.tblHead}>
                          <TableRow className={classes.tblHeadRow}>
                            <TableCell className={classes.tblHeadCell}>Priority</TableCell>
                            <TableCell className={classes.tblHeadCell}>{thFunding}</TableCell>
                            <TableCell className={classes.tblHeadCellR}>{thPtm}</TableCell>
                            <TableCell className={classes.tblHeadCellR}>{thPlm}</TableCell>
                            <TableCell className={classes.tblHeadCellR}>{thPytd}</TableCell>
                            <TableCell className={classes.tblHeadCellN}>Status</TableCell>
                          </TableRow>
                          <TableRow className={classes.tblHeadRow3}>
                            <TableCell className={classes.tblCellPriority}/>
                            <TableCell className={classes.tblCellAppCol}></TableCell>
                            <TableCell align="right"><Typography variant="subtitle2">{mtdSum}</Typography></TableCell>
                            <TableCell align="right"><Typography variant="subtitle2">{lmSum}</Typography></TableCell>
                            <TableCell align="right"><Typography variant="subtitle2">{ytdSum}</Typography></TableCell>
                            <TableCell className={classes.tblCellN}/>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        <Menu
                          id="action-menu"
                          anchorEl={this.state.activeMenu}
                          open={Boolean(this.state.activeMenu)}
                          onClose={this.handleActiveMenuClose}>
                          <MenuItem onClick={() => {this.suspend(actives)}}>
                            <ListItemIcon>
                              <PauseCircleOutline />
                            </ListItemIcon>
                            <ListItemText primary="Suspend"/>
                          </MenuItem>
                          <MenuItem onClick={() => {this.confirmDeactivate(actives)}}>
                            <ListItemIcon>
                              <CancelCircleOutline htmlColor={redColor}/>
                            </ListItemIcon>
                            <ListItemText primary="Deactivate"/>
                          </MenuItem>
                        </Menu>
                        <Menu
                          id="suspended-menu"
                          anchorEl={this.state.deactiveMenu}
                          open={Boolean(this.state.deactiveMenu)}
                          onClose={this.handleDeactiveMenuClose}>
                          <MenuItem onClick={() => {this.unsuspend(inactives, actives)}}>
                            <ListItemIcon>
                              <PlayCircleOutline htmlColor={okColor}/>
                            </ListItemIcon>
                            <ListItemText primary="Unsuspend"/>
                          </MenuItem>
                          <MenuItem onClick={() => {this.confirmDeactivate(inactives)}}>
                            <ListItemIcon>
                              <CancelCircleOutline htmlColor={redColor}/>
                            </ListItemIcon>
                            <ListItemText primary="Deactivate"/>
                          </MenuItem>
                        </Menu>

                          { actives.map(n => {
                            aCount++;
                            let mtd = Number(n.paidMtd)
                            .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                            let lm  = Number(n.paidLastMonth)
                            .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                            let ytd  = Number(n.paidYtd)
                            .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                            let curCount = aCount;

                            let upDisabled = true;
                            if (aCount > 1 && this.state.status !== "verifying") {
                              upDisabled = false;
                            }
                            let downDisabled = true;
                            if (aCount < actives.length && this.state.status !== "verifying") {
                              downDisabled = false;
                            }
                          
                            let declineCountTooltip = 'This funding source was declined the last time we attempted to charge it.  Please contact your bank to resolve any issues or add an alternate funding source.';
                            if (cp !== 'myfunding') {
                              declineCountTooltip = 'This funding source was declined the last time we attempted to charge it.  Please contact your customer so that they can resolve any issues or add an alternate funding source.';
                            }
                            if (n.lastDeclineReason) {
                              declineCountTooltip = declineCountTooltip +  abEnvironment.getDeclineReason(n.lastDeclineReason);
                            }
                            if (n.lastDeclineChargeAmount) {
                              let formattedDeclineAmount = Number(n.lastDeclineChargeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                              declineCountTooltip = declineCountTooltip + '  Amount of attempted charge was ' + formattedDeclineAmount;
                            }
                            /*
                            if (n.declineCount === 1) {
                              declineCountTooltip = 'Funding source has been declined 1 time';
                            } else if (n.declineCount > 1) {
                              declineCountTooltip = 'Funding source has been declined ' + n.declineCount + ' times';
                            }
                            */

                            return (
                              <TableRow key={n.psId}>
                                <TableCell className={classes.tblCellPriority}>
                                  <div className={classes.priorityGrid}>
                                  <IconButton
                                    className={classes.upbutton}
                                    disabled={upDisabled  || resellerViewingCustomerRestricted || this.state.swapping === true}
                                    onClick={() => {this.swapOrder(curCount-2, actives)}}
                                    size="large">
                                    <ArrowDropUp className={classes.iconbuttonicon}/>
                                  </IconButton>
                                  <Typography variant="h6" className={classes.priorityNum}>{curCount}</Typography>
                                  <IconButton
                                    className={classes.downbutton}
                                    disabled={downDisabled  || resellerViewingCustomerRestricted || this.state.swapping === true}
                                    onClick={() => {this.swapOrder(curCount-1, actives)}}
                                    size="large">
                                    <ArrowDropDown className={classes.iconbuttonicon}/>
                                  </IconButton>
                                  </div>
                                </TableCell>
                                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellAppCol}>
                                  <FundingSourceTile 
                                    psType={n.psType}
                                    ccBrand={n.ccBrand}
                                    ccLast4={n.ccLast4}
                                    ccExpy={n.ccExpy}
                                    fiName={n.fiName}
                                    achAccountNum={n.achAccountNum}
                                    firstName={n.firstName}
                                    lastName={n.lastName}
                                    paypalEmail={n.paypalEmail}
                                    extPsId={n.extPsId}
                                  />
                                </TableCell>
                                <TableCell align="right">{mtd}</TableCell>
                                <TableCell align="right">{lm}</TableCell>
                                <TableCell align="right">{ytd}</TableCell>
                                {/*(actives.length === 1) &&
                                  <TableCell align="center">
                                    {n.declineCount === 0 &&
                                      <CheckCircle htmlColor={okColor} className={classes.nonMenuStatus}/>
                                    }
                                    {n.declineCount !== 0 &&
                                      <Tooltip title={declineCountTooltip}>
                                        <ReportProblem htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                      </Tooltip>
                                    }
                                  </TableCell>
                                  */}
                                {actives.length > 0 &&
                                <TableCell align="center">

                                    <Button color="primary" 
                                      aria-owns={this.state.activeMenu ? 'simple-menu': undefined}
                                      aria-haspopup='true'
                                      disabled={this.state.status === "verifying" || resellerViewingCustomerRestricted}
                                      onClick={(e) => this.handleActiveMenuClick(e, curCount-1)} >
                                      {n.declineCount === 0 &&
                                         <CheckCircle htmlColor={okColor}/>
                                      }
                                      {n.declineCount !== 0 &&
                                        <Tooltip title={declineCountTooltip}>
                                          <ReportProblem htmlColor={yellowColor}/>
                                        </Tooltip>
                                      } 
                                    </Button>
  
                                  </TableCell>
                                }
                              </TableRow>
                            );
                          })}

                          { /* pendings.map (n => {
                            // Microdeposit flow
                            let dep1_label = 'dep1';
                            let dep2_label = 'dep2';
                            let curCount = 1;
                            let thePsId = null;
                            let dep1_value = null;
                            let dep2_value = null;
                            let verifyDisabled = true;
                
                            if (n.psStatus === 6 || n.psStatus === 8) {
                              pendingsDepCount = pendingsDepCount + 1;
                              dep1_label = 'dep1_' + pendingsDepCount;
                              dep2_label = 'dep2_' + pendingsDepCount;
                              curCount = pendingsDepCount;
                              thePsId = n.psId;
                              dep1_value = this.getValueForDepositRender(curCount, 0);
                              dep2_value = this.getValueForDepositRender(curCount, 1);

                              if (dep1_value > 0 && dep2_value > 0) {
                                verifyDisabled = false;
                              }
                            }

                            return (
                              <TableRow key={n.psId}>
                                <TableCell className={classes.tblCellPriority}/>
                                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellAppCol}>
                                  <FundingSourceTile 
                                    psType={n.psType}
                                    ccBrand={n.ccBrand}
                                    ccLast4={n.ccLast4}
                                    ccExpy={n.ccExpy}
                                    fiName={n.fiName}
                                    achAccountNum={n.achAccountNum}
                                    firstName={n.firstName}
                                    lastName={n.lastName}
                                  />
                                </TableCell>
                                <TableCell colSpan={3}>
                                  {// 4: Pending state - waiting for funding source to be setup 
                                  }
                                  {n.psStatus === 4 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Connecting to your bank account
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          A connection to your account is being established.  You'll be notified when your account is verified, or if you need to take
                                          further steps to verify your account.
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {// 5: Pending state - waiting for microdeposits to be made
                                  }
                                  {n.psStatus === 5 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Waiting for microdeposits
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          To verify your bank account information, two deposits of 10 cents or less have been initiated via ACH transfer.
                                          When these deposits have completed, you'll be notified so that you can enter the deposit amounts here to verify your account.
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 6 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Enter microdeposits
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          To verify your account, please enter the amounts of the two recent microdeposits from AppBind Inc.
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Grid container spacing={1} justifyContent="space-around">
                                          <Grid item>
                                            <TextField
                                              id={dep1_label} label="Deposit 1" 
                                              value={ dep1_value }
                                              onChange={ (e) => this.setDepositValue(curCount, 0,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            <TextField
                                              id={dep2_label} label="Deposit 2"
                                              value={ dep2_value }
                                              onChange={ (e) => this.setDepositValue(curCount, 1,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            <Button color="primary" variant="outlined" 
                                                    disabled={verifyDisabled}
                                                    onClick={() => {this.verifyDepositAmounts(thePsId, 
                                                      this.getValueForDepositRender(curCount, 0),
                                                      this.getValueForDepositRender(curCount, 1))}}>
                                              Verify 
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 7 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Waiting for account verification to complete
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          As soon as account verification is completed, your bank account will be an active funding source for AppBind. 
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 8 &&
                                  <React.Fragment>
                                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                      <Grid item>
                                        <Typography variant="subtitle2">
                                          Re-enter microdeposits
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Typography variant="caption">
                                          The values you entered previously did not match the microdeposits made to your account.  Please check your account, and try again.
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Grid container spacing={1} justifyContent="space-around">
                                          <Grid item>
                                            <TextField
                                              id={dep1_label} label="Deposit 1"
                                              value={ dep1_value }
                                              onChange={ (e) => this.setDepositValue(curCount, 0,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            <TextField
                                              id={dep2_label} label="Deposit 2"
                                              value={ dep2_value }
                                              onChange={ (e) => this.setDepositValue(curCount, 1,  e.target.value) }
                                              InputProps={{
                                                inputComponent: CurrencyNumberFormat2,
                                              }}
                                              inputProps={{
                                                minValue: 0.01,
                                                maxValue: 0.99
                                              }}
                                            />
                                          </Grid>
                                          <Grid item>
                                            <Button color="primary" variant="outlined" 
                                                    disabled={verifyDisabled}
                                                    onClick={() => {this.verifyDepositAmounts(thePsId, 
                                                      this.getValueForDepositRender(curCount, 0),
                                                      this.getValueForDepositRender(curCount, 1))}}>
                                              Verify 
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                  }
                                  {n.psStatus === 9 &&
                                  <React.Fragment>
                                    <Typography>
                                      This account could not be verified.  Please remove it, and try again.
                                    </Typography>
                                  </React.Fragment>
                                  }
                                </TableCell>
                                <TableCell align="center">
                                  {// 4: Pending state - initiation of verification
                                  }
                                  {n.psStatus === 4 &&
                                    <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                  }
                                  {// 5: Pending state - waiting for microdeposits to be made 
                                  }
                                  {n.psStatus === 5 &&
                                    <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                  }
                                  {// 6: Pending state - microdeposits have been made, now need user to verify 
                                  }
                                  {n.psStatus === 6 &&
                                    <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>
                                  }
                                  {// 7: Pending state - waiting for verification from Dwolla 
                                  }
                                  {n.psStatus === 7 &&
                                    <HourglassEmpty htmlColor={okColor} className={classes.nonMenuStatus}/>
                                  }
                                  {// 8: Verification failed, user can retry verification 
                                  }
                                  {n.psStatus === 8 &&
                                    <HourglassEmpty htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                  {// 9: Verification failed, user must restart the process - this source should be removed 
                                  }
                                  {n.psStatus === 9 &&
                                    <HourglassEmpty htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                  {n.psStatus === 3 &&
                                    <ErrorOutline htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                </TableCell>
                              </TableRow>
                            );
                          })
                          */}

                          { inactives.map(n => {
                            iCount++;
                            let mtd = Number(n.paidMtd)
                            .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                            let lm  = Number(n.paidLastMonth)
                            .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                            let ytd  = Number(n.paidYtd)
                            .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                            let curCount = iCount;

                            /* Suspended, cancelled */
                            return (
                              <TableRow key={n.psId}>
                                <TableCell className={classes.tblCellPriority}/>
                                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellAppCol}>
                                  <FundingSourceTile 
                                    psType={n.psType}
                                    ccBrand={n.ccBrand}
                                    ccLast4={n.ccLast4}
                                    ccExpy={n.ccExpy}
                                    fiName={n.fiName}
                                    achAccountNum={n.achAccountNum}
                                    firstName={n.firstName}
                                    lastName={n.lastName}
                                    paypalEmail={n.paypalEmail}
                                    extPsId={n.extPsId}
                                  />
                                </TableCell>
                                <TableCell align="right">{mtd}</TableCell>
                                <TableCell align="right">{lm}</TableCell>
                                <TableCell align="right">{ytd}</TableCell>
                                <TableCell align="center">
                                  {n.psStatus === 1 &&
                                  <React.Fragment>
                                    <Button color="primary" 
                                      aria-owns={this.state.deactiveMenu ? 'simple-menu': undefined}
                                      aria-haspopup='true'
                                      disabled={this.state.status === "verifying"}
                                      onClick={(e) => this.handleDeactiveMenuClick(e, curCount-1)} >
                                      <PauseCircleOutline />
                                    </Button>

                                  </React.Fragment>
                                  }
                                  {n.psStatus === 2 &&
                                  <CancelCircleOutline htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                  {n.psStatus === 3 &&
                                  <ErrorOutline htmlColor={redColor} className={classes.nonMenuStatus}/>
                                  }
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </div>
                    }

                    <Snackbar
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        open={this.state.snackbarOpen}
                        onClose={this.handleSnackbarClose}
                      >
                        <SnackbarContent
                          className={classNames(classes.message, classes[this.state.saveStatus])}
                          onClose={this.handleSnackbarClose}
                          message={
                            <Typography variant="body1">
                                {this.state.saveMessage}
                            </Typography>
                          }
                          action={[
                            <IconButton
                              key="close"
                              aria-label="Close"
                              color="inherit"
                              className={classes.close}
                              onClick={this.handleSnackbarClose}
                              size="large">
                            <CloseIcon />
                          </IconButton>
                        ]}
                      />
                    </Snackbar>

                    
                    <ConfirmationDialog
                      open={this.state.confirmDeactivate}
                      onClose={() => { this.setState({confirmDeactivate:false, activeList: ''});}}
                      onConfirm={() => {this.deactivate()}}
                      onCancel={() => { }}
                      title="Permanently deactivate funding source?"
                      cancelBtn="No"
                      okBtn="Yes, Permanently deactivate"
                      irreversibleAction={true}
                    >
                      Once deactivated, this funding source will no longer be usable in AppBind. If this is temporary, you can suspend the card instead.  

                      Are you sure you want to proceed?
                    </ConfirmationDialog>

                    <PaymentSourceDialog
                      title="Add credit card"
                      open={this.state.ccOpen}
                      onClose={this.handleCCClose} >
                          <PaymentFormII pcId={this.uInfo.stripeCid} 
                                      dAccountId={this.uInfo.accountId}
                                      dAccountName={this.uInfo.accountName}
                                      dFirstName={this.uInfo.firstName}
                                      dLastName={this.uInfo.lastName}
                                      dEmail={this.uInfo.email}
                                      dPhone={this.uInfo.phone}
                                      dAddress1={this.uInfo.address1}
                                      dAddress2={this.uInfo.address2}
                                      dCity={this.uInfo.city}
                                      dState={this.uInfo.state}
                                      dCountry={this.uInfo.country}
                                      dPostalCode={this.uInfo.postalCode}
                                      auth={this.props.auth}
                                      porder={maxPsOrder}
                                      setStripeCid={this.setStripeCidOnUInfo}
                                      history={this.props.history}
                                      onClose={this.handleCCClose}
                          />
                    </PaymentSourceDialog>

                    { (this.uInfo.achActive === "1" || this.uInfo.achActive === "2") && this.state.achOpen &&
                    <PaymentSourceDialog
                      title="Add US Bank Account (ACH)"
                      open={this.state.achOpen}
                      onClose={this.handleACHClose} >
      
                      <ACHFormII pcId={this.uInfo.dwollaCid} 
                              dAccountId={this.uInfo.accountId}
                              dAccountName={this.uInfo.accountName}
                              dFirstName={this.uInfo.firstName}
                              dLastName={this.uInfo.lastName}
                              dEmail={this.uInfo.email}
                              dPhone={this.uInfo.phone}
                              dAddress1={this.uInfo.address1}
                              dAddress2={this.uInfo.address2}
                              dCity={this.uInfo.city}
                              dState={this.uInfo.state}
                              dCountry={this.uInfo.country}
                              auth={this.props.auth}
                              porder={maxPsOrder}
                              setDwollaCidOnUInfo={this.setDwollaCidOnUInfo}
                              history={this.props.history}
                              onClose={this.handleACHClose}
                              />
                    </PaymentSourceDialog>
                    }
                    { (this.uInfo.achActive === "1" || this.uInfo.achActive === "2") && this.state.showPlaidMicro &&
                    <PaymentSourceDialog
                      title="Verify microdeposits"
                      open={this.state.showPlaidMicro}
                      onClose={this.handleACHMicroClose} >
      
                      <ACHFormIIPlaidMicro pcId={this.uInfo.dwollaCid} 
                              accessToken={this.state.accessToken}
                              dAccountId={this.uInfo.accountId}
                              dAccountName={this.uInfo.accountName}
                              dFirstName={this.uInfo.firstName}
                              dLastName={this.uInfo.lastName}
                              dEmail={this.uInfo.email}
                              dPhone={this.uInfo.phone}
                              dAddress1={this.uInfo.address1}
                              dAddress2={this.uInfo.address2}
                              dCity={this.uInfo.city}
                              dState={this.uInfo.state}
                              dCountry={this.uInfo.country}
                              auth={this.props.auth}
                              porder={maxPsOrder}
                              history={this.props.history}
                              onClose={this.handleACHMicroClose}
                              />


                    </PaymentSourceDialog>
                    }

                    {this.props.auth.isUnauthenticatedCustomer() && false &&
                    <Grid  container direction="row" justifyContent="center" alignItems="center">
                      <PoweredBy/>
                    </Grid>
                    }
                </div>
              );
            }
          }
          return <div><LoadingSpinner/></div>
        }}
      />
    );
  }
}

FundingSourceList.propTypes = {
    classes: PropTypes.object.isRequired,
  };

export default withStyles(styleSheet)(FundingSourceList);
